// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ewtpl6s5CvpLpt {
  width: 100%;
  border-radius: 3px;
  height: 60px;
  animation: mcSghiCoaT9uAH 1.5s infinite;
}
@keyframes mcSghiCoaT9uAH {
  0% {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
  100% {
    background-color: var(--ds-skeleton, #091e420f);
  }
}
.vrC_kXIbZ8tWSH {
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 0 1px var(--ds-border, #091e4224));
  transition: background 0.3s ease;
  text-rendering: geometricPrecision;
}
.Dc_AME4GV8BTn8 {
  background: var(--ds-surface-raised, #ffffff);
}
.Dc_AME4GV8BTn8 .EBTKIa7lEeLBeP {
  color: var(--ds-text, #172b4d);
}
.Dc_AME4GV8BTn8 .V3AovLCxDNWNDs {
  color: var(--ds-text-subtle, #44546f);
}
.Dc_AME4GV8BTn8 .BSYhIMmb6V6VP0 svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.Dc_AME4GV8BTn8 .Bu_UZykaDh96eO {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.Dc_AME4GV8BTn8 .ljpSsFGAMsxaEJ {
  background: var(--ds-background-neutral, #091e420f);
}
.Dc_AME4GV8BTn8 .VewLEt3HqiPYFi:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.L1rmKqCHsX7kv5 {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.L1rmKqCHsX7kv5 .EBTKIa7lEeLBeP {
  color: var(--ds-text-inverse, #ffffff);
}
.L1rmKqCHsX7kv5 .V3AovLCxDNWNDs {
  color: var(--ds-text-inverse, #ffffff);
}
.L1rmKqCHsX7kv5 .BSYhIMmb6V6VP0 svg {
  color: var(--ds-icon-discovery, #8270db);
}
.L1rmKqCHsX7kv5 .Bu_UZykaDh96eO {
  background: var(--ds-surface-raised, #ffffff);
}
.L1rmKqCHsX7kv5 .ljpSsFGAMsxaEJ {
  background: var(--ds-background-accent-purple-subtle, #9f8fef);
}
.L1rmKqCHsX7kv5 .VewLEt3HqiPYFi:hover {
  background: var(--ds-background-accent-purple-subtle, #583f68);
}
.EBTKIa7lEeLBeP {
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.003em;
  line-height: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
}
.V3AovLCxDNWNDs {
  margin-bottom: 16px;
}
.BSYhIMmb6V6VP0 {
  width: 26px;
  height: 26px;
  padding: 2px;
}
.BSYhIMmb6V6VP0 svg {
  width: 22px;
  height: 22px;
  line-height: 24px;
}
.Bu_UZykaDh96eO {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 3px;
  z-index: 2;
}
.ljpSsFGAMsxaEJ {
  position: absolute;
  bottom: -64px;
  right: -28px;
  width: 120px;
  height: 80px;
  border-radius: 12px;
  z-index: 1;
  transform: rotate(-50deg);
}
.VewLEt3HqiPYFi {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  padding: 4px;
  margin: 0;
  border: 0;
  width: 22px;
  height: 22px;
  display: flex;
}
.gXJiphSIbmGHO9 {
  line-height: 14px;
  margin-left: -1px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animation": `Ewtpl6s5CvpLpt`,
	"pulse": `mcSghiCoaT9uAH`,
	"upgradePromptFull": `vrC_kXIbZ8tWSH`,
	"upgradePromptFullLightTheme": `Dc_AME4GV8BTn8`,
	"upgradePromptFullHeadline": `EBTKIa7lEeLBeP`,
	"upgradePromptFullContent": `V3AovLCxDNWNDs`,
	"upgradePromptFullIcon": `BSYhIMmb6V6VP0`,
	"upgradePromptFullIconBackground": `Bu_UZykaDh96eO`,
	"upgradePromptFullIconClippedBackground": `ljpSsFGAMsxaEJ`,
	"upgradePromptFullCloseButtonWrapper": `VewLEt3HqiPYFi`,
	"upgradePromptFullDarkTheme": `L1rmKqCHsX7kv5`,
	"upgradePromptFullCloseButton": `gXJiphSIbmGHO9`
};
export default ___CSS_LOADER_EXPORT___;
